import { API_GATEWAY } from "configs/AppConfig"

export const signInRequest = async ({email, password}) => {
  return await fetch(`${API_GATEWAY}/users/signin`, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json'
    },
    body: JSON.stringify({email, password})
  }).then(res => {
    console.log('signInRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
} 

export const getUsersRequest = async (token, page, take, formParams) => {
  let query = `${API_GATEWAY}/users?take=${take}&page=${page}`;
  if (formParams) {
    query += `&where=${encodeURIComponent(JSON.stringify(formParams))}`
  }

  console.log('getUsersRequest', query);

  return await fetch(query, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getUsersRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const getUsersForExportRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/export-data`, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getUsersForExportRequest', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const getDefinedUserRequest = async (token, id) => {
  let query = `${API_GATEWAY}/users/${id}`;

  return await fetch(query, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getDefinedUserRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}


export const saveUserRequest = async (token, id, data) => {
  let query = `${API_GATEWAY}/users`;
  if (id !== "new") query += `/${id}`;

  console.log('saveUserRequest', query, data);

  return await fetch(query, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
    body: JSON.stringify(data)
  }).then(res => {
    console.log('saveUserRequest result', res.status);
    if (res.status < 400) return res.json();
    return null;
  });
}

export const refreshTokenRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/refresh-token`, {
    method: "PATCH",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json'
    },
    body: JSON.stringify({token})
  }).then(res => {
    console.log('refreshTokenRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
} 

export const getUserGroupsRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/groups`, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getUserGroupsRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const blockUserGroupsRequest = async (token, patterns) => {
  return await fetch(`${API_GATEWAY}/users/groups/block`, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
    body: JSON.stringify({ patterns })
  }).then(res => {
    console.log('blockUserGroupsRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const blockNonWhitelistedRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/groups/block-non-whitelisted`, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('blockNonWhitelistedRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const getGroupRulesRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/group-rules`, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getGroupRulesRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const addGroupRuleRequest = async (token, pattern) => {
  return await fetch(`${API_GATEWAY}/users/group-rules`, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
    body: JSON.stringify({ pattern })
  }).then(res => {
    console.log('addGroupRuleRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const deleteGroupRuleRequest = async (token, id) => {
  return await fetch(`${API_GATEWAY}/users/group-rules/${id}`, {
    method: "DELETE",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('deleteGroupRuleRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const getGroupStatusRequest = async (token) => {
  return await fetch(`${API_GATEWAY}/users/group-status`, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('getGroupStatusRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const setGroupStatusRequest = async (token, status) => {
  return await fetch(`${API_GATEWAY}/users/group-status`, {
    method: "POST",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
    body: JSON.stringify({ status })
  }).then(res => {
    console.log('setGroupStatusRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}

export const manageUserStatusRequest = async (token, userId, command) => {
  let query = `${API_GATEWAY}/users/${userId}/manage/${command}`;

  return await fetch(query, {
    method: "GET",
		mode: 'cors',
		headers: {
			accept: '*/*',
			'Content-Type': 'application/json',
      "Api-Token": token,
    },
  }).then(res => {
    console.log('manageUserStatusRequest result', res.status);
    if (res.status === 200) return res.json();
    return null;
  });
}